/**
 * 移动端返回键处理器
 * 
 * 解决问题：在手机浏览器/微信/QQ中，打开图片预览、弹窗等全屏覆盖层时，
 * 点击浏览器返回键应该关闭覆盖层而非返回上一页。
 * 
 * 原理：
 * 1. 监听 Element UI 图片预览器的打开/关闭
 * 2. 打开时 pushState，关闭时对应的 popstate 会被消费
 * 3. 按返回键触发 popstate，关闭预览而非离开页面
 */

let isViewerOpen = false
let observer = null

function isMobile () {
  return window.innerWidth < 768
}

/**
 * 关闭 el-image-viewer
 */
function closeImageViewer () {
  const closeBtn = document.querySelector('.el-image-viewer__close')
  if (closeBtn) {
    closeBtn.click()
    return true
  }
  return false
}

/**
 * popstate 处理：如果图片预览打开则关闭它
 */
function handlePopState () {
  if (isViewerOpen && isMobile()) {
    closeImageViewer()
    isViewerOpen = false
  }
}

/**
 * 监听 DOM 变化，检测 el-image-viewer 的出现和消失
 */
function setupMutationObserver () {
  if (observer) return

  observer = new MutationObserver((mutations) => {
    if (!isMobile()) return

    for (const mutation of mutations) {
      // 检测新增节点
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (
          node.classList?.contains('el-image-viewer__wrapper') ||
          node.querySelector?.('.el-image-viewer__wrapper')
        )) {
          if (!isViewerOpen) {
            isViewerOpen = true
            window.history.pushState({ imageViewer: true }, '', '')
          }
        }
      }
      // 检测移除节点
      for (const node of mutation.removedNodes) {
        if (node.nodeType === 1 && (
          node.classList?.contains('el-image-viewer__wrapper') ||
          node.querySelector?.('.el-image-viewer__wrapper')
        )) {
          if (isViewerOpen) {
            isViewerOpen = false
            // 不需要 history.back()，因为可能是用户点了关闭按钮或 popstate 已经触发
          }
        }
      }
    }
  })

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })
}

/**
 * 初始化移动端返回键处理
 * 在 main.js 中调用一次即可
 */
export function initMobileBackHandler () {
  window.addEventListener('popstate', handlePopState)
  
  // DOM ready 后启动 MutationObserver
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setupMutationObserver()
  } else {
    document.addEventListener('DOMContentLoaded', setupMutationObserver)
  }
}

/**
 * 销毁（通常不需要，除非 SPA 卸载时）
 */
export function destroyMobileBackHandler () {
  window.removeEventListener('popstate', handlePopState)
  if (observer) {
    observer.disconnect()
    observer = null
  }
}
